/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module core/modules/reg-exp-utils/check-none */
import { checkOne } from './check-one.js';
/** @typedef {(string|RegExp|Array<(string|RegExp)>)} checkNoneRawExpType */

/**
 * @description Checks input against all items in rawExp and returns a truthy value if no match is found.
 * @param {string} str - Input string.
 * @param {checkNoneRawExpType} rawExp - Expression to check.
 * @returns {boolean} Result.
 */

function checkNone(str, rawExp) {
  return !checkOne(str, rawExp);
}

export { checkNone };